export const MOCK_CODE_GITHUB = 'MOCK_CODE_GITHUB_KODY'
export const MOCK_CODE_GITHUB_HEADER = 'x-mock-code-github'
export const MAX_META_TITLE_LENGTH = 60
export const MAX_META_DESCRIPTION_LENGTH = 160
export const MAX_META_FIRST_LINE_DESCRIPTION_LENGTH = 87
